export const contentReplace = (text: string, key: string, replace: string) => {
  return text?.replaceAll(key, replace);
};

export const replaceProjectName = (text: string) => {
  const config = useAppConfig();
  return text?.replaceAll('{{projectName}}', config?.customer?.projectName);
};
